import React from "react";
import "./Categories.css";
import { HeroImage } from "../../../../images/Images";

const categories = [
  { name: "Vegetables", image: HeroImage },
  { name: "Spices", image: HeroImage },
  { name: "Oil", image: HeroImage },
  { name: "Flour", image: HeroImage },
  { name: "Seeds", image: HeroImage },
  { name: "Nuts", image: HeroImage },
  { name: "Staple foods", image: HeroImage },
  { name: "Frozen food", image: HeroImage },
  { name: "Proteins", image: HeroImage },
  { name: "Seafood", image: HeroImage },
  { name: "Greens", image: HeroImage },
  { name: "Fruits", image: HeroImage },
];

const Categories: React.FC = () => {
  return (
    <div className="retail-categories-container">
      <h2 className="retail-categories-title">Categories</h2>
      <div className="retail-categories-grid">
        {categories.map((category, index) => (
          <div key={index} className="retail-categories-card">
            <img
              src={category.image}
              alt={category.name}
              className="retail-categories-image"
            />
            <span className="retail-categories-label">{category.name}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Categories;
